import { Loader, Skeleton, Stack } from '@mantine/core';
import { FC, useContext } from 'react';
import BookitupAddIcon from '../../../Atoms/BookitupAddIcon';
import EmptyText from '../../../Atoms/EmptyText';
import NoteItem from '../../../Molecules/Logs/NoteItem';
import PanePaper from '../../../Molecules/PanePaper';
import { ViolationContext } from '../../../Service/Context/ViolationContext';
import { LicenceS } from '../../../Service/LicenceS';
import { useEventScope } from '../../../Service/hooks/useEventScope';
import { useNotes } from '../../../Service/hooks/useNotes';

const ContactNoteList: FC<{ contactId: string; withoutBorder?: boolean }> = ({ contactId, withoutBorder = false }) => {
  const { executeWithLicenceCheck } = useContext(ViolationContext);
  const { isEventScope } = useEventScope();

  const { loading, addingNote, notes, update, remove, add } = useNotes('contacts', contactId);
  const { length } = notes;

  const getAddIcon = () => {
    if (addingNote) return <Loader size="xs" />;
    if (notes.length > 0) {
      return (
        <BookitupAddIcon onClick={() => executeWithLicenceCheck(LicenceS.Restrictions.MULTIPLE_EVENT_NOTES, add)} />
      );
    }
    return <BookitupAddIcon onClick={add} />;
  };

  return (
    <PanePaper
      borderlessVersion={withoutBorder}
      title={isEventScope ? undefined : 'common.notes'}
      tooltip="help.event.notes.pane"
      rightSection={withoutBorder ? undefined : getAddIcon()}
    >
      {!loading && !addingNote && length === 0 && <EmptyText />}
      {(loading || addingNote) && <Skeleton height={100} width="100%" />}
      {length > 0 && (
        <Stack>
          {notes.map((note: any) => (
            <NoteItem key={note.id} note={note} updateHandler={update} deleteHandler={remove} />
          ))}
        </Stack>
      )}
    </PanePaper>
  );
};

export default ContactNoteList;
